export const isPublicTabUrl = (value: string | null): value is string => {
  if (!value) return false;

  try {
    const url = new URL(value);
    const hostname = url.hostname.toLowerCase().replace(/\.$/, '');
    const isIpv4 = /^(?:\d{1,3}\.){3}\d{1,3}$/.test(hostname);

    return (
      url.protocol === 'https:' &&
      Boolean(hostname) &&
      !url.username &&
      !url.password &&
      (!url.port || url.port === '443') &&
      hostname !== 'localhost' &&
      !isIpv4 &&
      !hostname.includes(':') &&
      /^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/i.test(
        hostname,
      )
    );
  } catch {
    return false;
  }
};
